import axiosInstance from "@/services/AxiosTokenInstance";
import { i18n, defaultLanguage } from "@/i18n";

// Untranslated keys come back as null (or ""); dropping them lets vue-i18n fall back to English
// instead of showing nothing or the raw key.
function withoutEmpty(messages) {
  return Object.fromEntries(
    Object.entries(messages ?? {}).filter(
      ([, value]) => typeof value === "string" && value.trim() !== "",
    ),
  );
}

async function loadMessages(isocode) {
  const response = await axiosInstance.get(`translations/print/${isocode}`);
  i18n.global.setLocaleMessage(isocode, withoutEmpty(response.data));
}

// English is the fallback locale; without its messages a missing translation shows the key itself
// (e.g. "ROLE_SUPERIOR"). Loaded once per page load.
let fallbackLoading = null;
function ensureFallbackMessages() {
  if (!fallbackLoading) {
    fallbackLoading = loadMessages(defaultLanguage).catch((error) => {
      fallbackLoading = null;
      throw error;
    });
  }
  return fallbackLoading;
}

export async function fetchTranslations(isocode) {
  try {
    await Promise.all([
      loadMessages(isocode),
      // The fallback must never block the chosen language
      isocode !== defaultLanguage
        ? ensureFallbackMessages().catch((error) => console.error(error))
        : null,
    ]);
    if (isocode === defaultLanguage) {
      fallbackLoading = Promise.resolve();
    }
    if (typeof i18n.global.locale === "string") {
      i18n.global.locale = isocode;
    } else {
      i18n.global.locale.value = isocode;
    }
    document.documentElement.lang = isocode;
  } catch (error) {
    console.error(error);
  }
}

export function useTranslation() {
  return { fetchTranslations };
}
